import { authChannel, AuthMessage, SessionAction } from "@/entities/session";
import { Dispatch, RefObject, useEffect } from "react";

export const useSessionCrossTabSync = (
    dispatch: Dispatch<SessionAction>,
    tokenRef: RefObject<string | null>
) => {
    useEffect(() => {
        const handler = (event: MessageEvent<AuthMessage>) => {
            if (event.data.type === 'LOGOUT') {
                tokenRef.current = null;
                dispatch({ type: 'LOGOUT' });
            }
        };
        authChannel.addEventListener('message', handler);
        return () => authChannel.removeEventListener('message', handler);
    }, []);
};